<template>
  <div class="main-hms" style="background-image:url(@/assets/dsm.png)">
    <Input placeholder="Input Number" :inputValue.sync="numberInput" @enter="btnClick" />
    <button @click="btnClick()">Test</button>
    <!-- <div class="numbers" >
      <div v-for="n in number.toString().length" :key="n" class="seven-section">
        <div :class="seg4Class" ref="seg4">
          <div class="top-right"></div>
          <div class="bottom-right"></div>
          <div class="top-left"></div>
          <div class="bottom-left"></div>
        </div>
        <div :class="seg1Class" ref="seg1"></div>
        <div :class="seg7Class" ref="seg7"></div>
        <div :class="seg2Class" ref="seg2"></div>
        <div :class="seg3Class" ref="seg3"></div>
        <div :class="seg5Class" ref="seg5"></div>
        <div :class="seg6Class" ref="seg6"></div>

        <div class="top-right-corner"></div>
        <div class="top-left-corner"></div>
        <div class="bottom-right-corner"></div>
        <div class="bottom-left-corner"></div>
      </div>
    </div> -->

    <DatePicker style="margin-top: 0px; margin-left: 0px" :value.sync="selectedDateTime" defaultTime="00:00" :minDate="new Date(2019, 10, 10)" :maxDate="new Date(2019, 11, 9)" />
    {{ selectedDateTime }}

    <button @click="startTyping">Start</button>

    <div style="background-color: red; width: 200px; text-align: center">
      {{ typeWriterText }}
    </div>

    <!-- <button @click="playAnimation('e')">Play E</button>
    <button @click="playAnimation('l')">Play L</button>
    <button @click="playAnimation('m')">Play M</button>
    <button @click="playAnimation('s')">Play S</button> -->
    <!-- <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid meet" viewBox="0 0 2000 640" width="640" height="640"> -->
    <!-- <g> -->
    <!-- Original -->
    <!-- <path class="elms" :style="{ animationPlayState: animationE }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="blue" stroke-width="15" d="M220 399.45C153.34 419.4 120.02 411.06 120.02 374.44C120.02 337.82 142.46 320.49 187.35 322.46C144.34 328.87 121.89 317.02 120.02 286.9C118.14 256.78 147.3 251.95 207.5 272.43" id="a3F7pUiHhx"></path>
    <path class="elms" :style="{ animationPlayState: animationL }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="blue" stroke-width="15" d="M326.4 410C290.73 410 268.45 410 259.53 410C245.21 410 233.6 398.39 233.6 384.07C233.6 366.81 233.6 323.65 233.6 254.59" id="a2g6TFsHOy"></path>
    <path class="elms elmsM" :style="{ animationPlayState: animationM }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="blue" stroke-width="15" d="M436.91 415.77C439.16 311.96 430.7 260.06 411.54 260.06C392.38 260.06 383.93 311.96 386.18 415.77C384.58 309.93 374.53 258.01 356.01 260C337.5 261.99 330.64 313.91 335.44 415.77" id="b1UK7TqCNx"></path>
    <path class="elms" :style="{ animationPlayState: animationS }" style="animation-delay: 0s; animation-duration: 1.5s" fill="none" stroke="blue" stroke-width="15" d="M452.61 377.83C450.27 389.95 459.44 400.11 480.11 408.31C511.12 420.62 576.73 362.83 494.05 324.25C426.78 292.86 458.8 257.79 498.2 260.11C518.96 261.33 528.09 266.34 525.59 275.13" id="ezUDiB0I3"></path> -->
    <!-- Original -->
    <!-- My Name -->
    <!-- <path class="name" fill="none" stroke="black" stroke-width="10" d="M1703.13 186.11C1689.87 191.03 1687.13 197.2 1694.89 204.61C1706.53 215.73 1716.97 213.62 1730.65 215.98C1764.01 221.73 1717.82 262.54 1711.86 241.13C1702.9 208.92 1784.97 211.41 1820 210.98C1954.75 209.36 1890.59 246.31 1886.81 245.35C1864.1 239.64 1884.29 215.5 1901.8 217.23C1969.11 223.89 1947.29 304.67 1916.64 351.64C1885.98 398.61 1859.72 396.19 1848.02 386.81C1808.56 355.16 1879.79 264.36 1871.47 285.89C1843.11 359.28 1790.35 389.75 1765.63 409.98C1676.25 483.14 1749.92 476.84 1765.63 460.13C1838.13 383 1766.67 353.95 1776.52 349.09C1817.01 329.12 1819.88 281.74 1796.88 278.76C1773.87 275.78 1757.46 289.06 1752.05 316.71C1746.64 344.36 1716.21 392.04 1693.28 389.32C1640.77 383.09 1711.82 262.02 1708.41 281.31C1701.1 322.66 1639.08 391.12 1615.12 401.88C1524.1 442.72 1545.67 509.05 1606.6 458.62C1667.53 408.18 1600.26 358.49 1617.59 347.16C1664.87 316.28 1649.16 272.59 1617.92 281.31C1586.68 290.03 1561.38 434.25 1526.59 381.78C1491.79 329.31 1634.47 162.87 1546.88 304.89C1459.28 446.92 1422.6 378.04 1423.74 346.62C1426.99 257.69 1518.26 185.32 1542.74 175.82C1607.19 150.83 1583.58 254 1585.94 226.05C1600.65 51.39 1338.64 365.73 1331.63 371.75C1309.25 390.99 1287.87 397.13 1289.06 359.25C1292.35 255.01 1358.77 156.08 1356.52 166.41C1350.08 195.92 1294.07 307.42 1290.26 317.78C1280.45 344.47 1239.26 396.25 1218.75 387.05C1198.24 377.86 1215.73 345.49 1227.27 321.52C1258.91 255.83 1297.66 285.15 1285.81 281.33C1232.76 264.22 1211.52 365.66 1189.81 377.75C1102.96 426.12 1165.18 322.81 1163.03 328.04C1155.27 346.93 1123.25 386.59 1109.38 391.85C1057.34 411.55 1079.67 330.61 1103.75 308.47C1175.99 242.04 1167.04 314.39 1167.93 305.89C1172.43 263.37 1126.53 285.95 1120.36 291.38C1091.86 316.44 1061.36 387.37 1041.88 388.73C990.14 392.34 1064.82 311.73 1028.76 307.78C992.69 303.84 954.84 398.36 958.51 384.62C1016.57 167.64 880.8 395.43 885.62 385.98C907.88 342.39 915.83 287.28 909.25 311.47C892.94 371.46 863.52 388.26 850 387.03C812.79 383.66 860.96 311.29 837.55 307.5C814.14 303.7 764.17 413.7 772.25 381.8C826.15 169.11 692.92 400.87 700.46 386.91C723.09 345.03 719.05 290 718.75 306.29C717.91 352.41 671.12 392.32 661.03 391.85C621.17 389.97 657.02 333.77 660.57 327.18C671.55 306.79 634.63 368.99 617.27 381.8C555.25 427.54 582.17 327.32 603.28 307.6C670.65 244.64 663.83 312.23 665.4 307.07C671.94 285.57 651.69 277.99 640.63 281.33C587.95 297.22 576.79 372.08 546.88 381.8C478.37 404.06 559.92 313.33 518.55 298.42C477.18 283.52 446.38 442.81 448.32 391.85C456.07 188.01 547.6 125.92 529.25 180.86C470.69 356.22 395.88 393.91 384.79 389.45C354.81 377.4 396.23 290.13 390.63 307.47C373.99 358.99 345.91 392.06 333.18 388.22C286.61 374.18 348.38 281.89 337.81 297.46C305.44 345.14 320.06 395.28 277.77 391.85C235.48 388.41 287.91 205.4 293.87 180.86C312.14 105.75 199.6 386.6 198.12 369.14C192.43 301.98 207.2 183.96 200.77 184.87C178.62 188.01 100.16 409.34 103.14 396.08C114.32 346.37 210.47 161.15 190.36 160.77C150.55 160.01 132.42 183.45 135.98 231.1" id="aQziHChGW"></path> -->
    <!-- My Name -->
    <!-- </g> -->
    <!-- </defs>
    <g><g><g><use xlink:href="#aaRv493Z1" opacity="1" fill-opacity="0" stroke="#347102" stroke-width="3" stroke-opacity="1"></use></g></g><g></g><g></g><g></g><g></g><g><g><use xlink:href="#b22outN01a" opacity="1" fill-opacity="0" stroke="#347102" stroke-width="3" stroke-opacity="1"></use></g></g><g></g></g> -->
    <!-- </svg> -->

    <Input placeholder="Name" :inputValue.sync="nameText" :errorMessage="nameError" textAlign="center" :isRequired="true" />
    <Input placeholder="Age" :inputValue.sync="ageText" :errorMessage.sync="ageError" textAlign="right" :isRequired="true" />
    <Input placeholder="Position" :inputValue.sync="positionText" :errorMessage.sync="positionError" :isRequired="true" />

    <button @click="dataAnnotationTest()">Click Me</button>
  </div>
</template>

<script>
/* eslint-disable */
  import Input from '@/components/Input.vue';
  import DatePicker from '@/components/DateTimePicker.vue';

  var index = 0;

  export default {
    components: {
      Input, DatePicker
    },
    props: {
      seg1Class: { type: String, default: 'top top-bottom-margin hide' },
      seg2Class: { type: String, default: 'left-top hide' },
      seg3Class: { type: String, default: 'right-top hide' },
      seg4Class: { type: String, default: 'mid hide' },
      seg5Class: { type: String, default: 'left-bottom hide' },
      seg6Class: { type: String, default: 'right-bottom hide' },
      seg7Class: { type: String, default: 'bottom top-bottom-margin hide' },
      number: { type: Number, default: 0 },
      numberInput: { type: String, default: '' },

      selectedDateTime: { type: Date, default: null },
      // selectedDateTime: { type: Date, default: new Date('2019-05-13 16:45') }

      typeWriterText: { type: String, default: '' },
      textToShow: { type: String, default: 'My name is Muhammad Azizi bin Abdul Aziz' },

      animationE: { type: String, default: 'paused' },
      animationL: { type: String, default: 'paused' },
      animationM: { type: String, default: 'paused' },
      animationS: { type: String, default: 'paused' },

      nameError: { type: String, default: '' },
      ageError: { type: String, default: '' },
      positionError: { type: String, default: '' },

      nameText: { type: String, default: '' },
      ageText: { type: String, default: '' },
      positionText: { type: String, default: '' },
    },
    methods: {
      btnClick: function () {
        // this.number = parseInt(this.numberInput);
        var num = this.number.toString();

        for (var i = 0; i < num.length; i++) {
          this.hideAll(i);
          switch (num[i]) {
            case '0':
              this.show0(i);
              break;
            case '1':
              this.show1(i);
              break;
            case '2':
              this.show2(i);
              break;
            case '3':
              this.show3(i);
              break;
            case '4':
              this.show4(i);
              break;
            case '5':
              this.show5(i);
              break;
            case '6':
              this.show6(i);
              break;
            case '7':
              this.show7(i);
              break;
            case '8':
              this.show8(i);
              break;
            case '9':
              this.show9(i);
              break;
          }
        }

        this.number++;
        // if (this.number > 9) {
        //   this.number = 0;
        // }
      },
      hideAll: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('show', 'hide');
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('show', 'hide');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('show', 'hide');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('show', 'hide');
        this.$refs.seg5[index].className = this.$refs.seg5[index].className.replace('show', 'hide');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('show', 'hide');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('show', 'hide');
      },
      show0: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg5[index].className = this.$refs.seg5[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },
      show1: function (index) {
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
      },
      show2: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg5[index].className = this.$refs.seg5[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },
      show3: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },
      show4: function (index) {
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
      },
      show5: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },
      show6: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg5[index].className = this.$refs.seg5[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },
      show7: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
      },
      show8: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg5[index].className = this.$refs.seg5[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },
      show9: function (index) {
        this.$refs.seg1[index].className = this.$refs.seg1[index].className.replace('hide', 'show');
        this.$refs.seg2[index].className = this.$refs.seg2[index].className.replace('hide', 'show');
        this.$refs.seg3[index].className = this.$refs.seg3[index].className.replace('hide', 'show');
        this.$refs.seg4[index].className = this.$refs.seg4[index].className.replace('hide', 'show');
        this.$refs.seg6[index].className = this.$refs.seg6[index].className.replace('hide', 'show');
        this.$refs.seg7[index].className = this.$refs.seg7[index].className.replace('hide', 'show');
      },

      startTyping: function (e) {
        if (e) {
          this.typeWriterText = '';
          index = 0;
        }

        if (index < this.textToShow.length) {
          this.typeWriterText += this.textToShow[index];
          if (this.textToShow[index + 1] == ' ') {
            this.typeWriterText += ' ';
            index++;
          }
          setTimeout(this.startTyping, 70);
          index++;
        }
      },
      playAnimation(obj) {
        this.animationE = this.animationE == 'paused' ? 'running' : 'paused';
        this.animationL = this.animationL == 'paused' ? 'running' : 'paused';
        this.animationM = this.animationM == 'paused' ? 'running' : 'paused';
        this.animationS = this.animationS == 'paused' ? 'running' : 'paused';

        // if (this.animationS == 'paused') {
        //   this.animationS = 'running';
        // } else {
        //   this.animationS = 'paused';
        // }
        // switch (obj) {
        //   case 'e':
        //     this.animationE = this.animationE == 'paused' ? 'running' : 'paused';
        //     break;
        //   case 'l':
        //     this.animationL = this.animationL == 'paused' ? 'running' : 'paused';
        //     break;
        //   case 'm':
        //     this.animationM = this.animationM == 'paused' ? 'running' : 'paused';
        //     break;
        //   case 's':
        //     this.animationS = this.animationS == 'paused' ? 'running' : 'paused';
        //     break;
        // }
      },
      sleep: function (ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },
      dataAnnotationTest: async function () {
        this.clearError();

        var obj = await this.$apiCallV2('/SampleData/Test', {
          Name: this.nameText,
          Age: this.ageText,
          Position: this.positionText
        });

        if (obj.data.status != 0) {
          console.log(obj.data);
          obj.data.error.forEach((e) => {
            var errorName = e.Key.toLowerCase() + 'Error';
            this[errorName] = e.Value;
          });
        } else {
          console.log(JSON.parse(obj.data.data).Name);
        }

        // this.nameError = 'Name is required';
      },
      clearError: function () {
        this.nameError = '';
        this.ageError = '';
        this.positionError = '';
      }
    },
    watch: {
      numberInput: function (val) {
        for (var i = 0; i < val.length; i++) {
          this.hideAll(i);
          switch (num[i]) {
            case '0':
              this.show0(i);
              break;
            case '1':
              this.show1(i);
              break;
            case '2':
              this.show2(i);
              break;
            case '3':
              this.show3(i);
              break;
            case '4':
              this.show4(i);
              break;
            case '5':
              this.show5(i);
              break;
            case '6':
              this.show6(i);
              break;
            case '7':
              this.show7(i);
              break;
            case '8':
              this.show8(i);
              break;
            case '9':
              this.show9(i);
              break;
          }
        }
      }
    },
    imageChange() {

    },
    async mounted() {
      // setInterval(() => {
      //   this.btnClick();
      // }, 1);
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/css/all.scss';

  $segment-color: white;
  $mid-color: black;
  $mid-size: 13px;
  $size: 20px;

  .main-hms {
    width: 100%;
    height: 100%;
    padding: 10px 40px;
  }

  .numbers {
    display: flex;
    margin-top: 20px;
    // background-color: blue;
    width: 100%;
    height: 200px;
  }

  .hide {
    opacity: 0.075;
  }

  .show {
    opacity: 1;
  }

  .seven-section .top-right-corner {
    position: absolute;
    top: 0;
    right: 0;
    border-top: $size * 0.75 solid $segment-color;
    border-left: $size * 0.75 solid transparent;
  }

  .seven-section .bottom-right-corner {
    position: absolute;
    bottom: 0;
    right: 0;
    border-right: $size * 0.75 solid $segment-color;
    border-top: $size * 0.75 solid transparent;
  }

  .seven-section .top-left-corner {
    position: absolute;
    top: 0;
    left: 0;
    border-top: $size * 0.75 solid $segment-color;
    border-right: $size * 0.75 solid transparent;
  }

  .seven-section .bottom-left-corner {
    position: absolute;
    bottom: 0;
    left: 0;
    border-left: $size * 0.75 solid $segment-color;
    border-top: $size * 0.75 solid transparent;
  }

  .seven-section {
    position: relative;
    background-color: $segment-color;
    width: 120px;
    height: 200px;
    margin: 0 5px;
  }

    .seven-section .top {
      position: absolute;
      top: 0;
      width: 100%;
      border-top: $size solid $mid-color;
      border-left: $size solid transparent;
      border-right: $size solid transparent;
    }

    .seven-section .bottom {
      position: absolute;
      bottom: 0;
      border-bottom: $size solid $mid-color;
      border-left: $size solid transparent;
      border-right: $size solid transparent;
    }

    .seven-section .top-bottom-margin {
      left: 3px;
      width: calc(100% - 6px);
    }

    .seven-section .right-top {
      position: absolute;
      top: 3px;
      right: 0;
      height: calc(50% - 6px);
      border-right: $size solid $mid-color;
      border-bottom: $size - 5px solid transparent;
      border-top: $size solid transparent;
    }

    .seven-section .right-bottom {
      position: absolute;
      bottom: 3px;
      right: 0;
      height: calc(50% - 6px);
      border-right: $size solid $mid-color;
      border-bottom: $size solid transparent;
      border-top: $size - 5px solid transparent;
    }

    .seven-section .left-top {
      position: absolute;
      top: 3px;
      left: 0;
      height: calc(50% - 6px);
      border-left: $size solid $mid-color;
      border-bottom: $size - 5px solid transparent;
      border-top: $size solid transparent;
    }

    .seven-section .left-bottom {
      position: absolute;
      bottom: 3px;
      left: 0;
      height: calc(50% - 6px);
      border-left: $size solid $mid-color;
      border-bottom: $size solid transparent;
      border-top: $size - 5px solid transparent;
    }

    .seven-section .mid {
      position: absolute;
      top: calc(50% - #{$mid-size});
      left: 3px;
      width: calc(100% - 6px);
      height: $mid-size * 2;
      background-color: $mid-color;
    }

  .mid .top-right {
    position: absolute;
    right: 0;
    height: $mid-size;
    width: $mid-size;
    border-top: $mid-size solid $segment-color;
    border-left: $mid-size + 5px solid $mid-color;
  }

  .mid .bottom-right {
    position: absolute;
    right: 0;
    top: 50%;
    height: $mid-size;
    width: $mid-size;
    border-top: $mid-size solid $mid-color;
    border-right: $mid-size + 5px solid $segment-color;
  }

  .mid .top-left {
    position: absolute;
    left: 0;
    height: $mid-size;
    width: $mid-size;
    border-top: $mid-size solid $segment-color;
    border-right: $mid-size + 5px solid $mid-color;
  }

  .mid .bottom-left {
    position: absolute;
    left: 0;
    top: 50%;
    height: $mid-size;
    width: $mid-size;
    border-top: $mid-size solid $mid-color;
    border-left: $mid-size + 5px solid $segment-color;
  }

  .elms {
    stroke-dasharray: 500;
    animation: animate 2s linear infinite;
  }

  @keyframes animate {
    to {
      stroke-dashoffset: 1000;
    }
  }

  .elmsM {
    stroke-dasharray: 1000;
    animation: animateM 2s linear infinite;
  }

  @keyframes animateM {
    to {
      stroke-dashoffset: 2000;
    }
  }

  .input-error {
    color: red;
    margin-top: -5px;
  }

  // Region My Name
  $name-dashoffset: 20000;
  .name {
    stroke-dasharray: calc(#{$name-dashoffset} / 2);
    animation: name-animation 10s linear infinite;
  }

  @keyframes name-animation {
    to {
      stroke-dashoffset: $name-dashoffset;
    }
  }

  // End Region My Name
</style>